import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';
import '../styles/Library.css';
import getBookCoverUrl from '../utils/getBookCoverUrl';

const Library = () => {
  const [books, setBooks] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [sortBy, setSortBy] = useState('alphabetical');
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchReadingList = async () => {
      const token = localStorage.getItem('token');
      if (!token) {
        navigate('/login');
        return;
      }

      try {
        const response = await api.get('/library/reading-list', {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });

        const updatedBooks = response.data.map(book => ({
          ...book,
          cover_image_url: getBookCoverUrl(book.cover_image_url)
        }));

        setBooks(updatedBooks);
        setIsLoading(false);
      } catch (error) {
        console.error('Error fetching reading list:', error);
        setError('Failed to fetch reading list. Please try again.');
        setIsLoading(false);

        if (error.response?.status === 401) {
          localStorage.removeItem('token');
          navigate('/login');
        }
      }
    };

    fetchReadingList();
  }, [navigate]);

  const handleBookClick = (bookId) => {
    navigate(`/book/${bookId}`);
  };

  const filteredBooks = books.filter(book =>
    book.title.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const sortedBooks = [...filteredBooks].sort((a, b) => {
    if (sortBy === 'alphabetical') return a.title.localeCompare(b.title);
    if (sortBy === 'lastRead') return new Date(b.last_read) - new Date(a.last_read);
    return 0;
  });

  if (isLoading) return <div className="library-loading-container">Loading...</div>;
  if (error) return <div className="library-error-container">{error}</div>;

  return (
    <div className="library-container">
      <div className="library-hero">
        <h1 className="library-title">Kütüphanem</h1>
      </div>

      <div className="library-controls">
        <div className="library-search">
          <input 
            type="text" 
            placeholder="      Search books or authors..." 
            value={searchTerm} 
            onChange={(e) => setSearchTerm(e.target.value)}
            className="library-search-input"
          />
        </div>
        <div className="library-sort">
          <button 
            className={`library-sort-button ${sortBy === 'alphabetical' ? 'active' : ''}`}
            onClick={() => setSortBy('alphabetical')}
          >
            <span className="sort-icon">🔤</span> Alphabetical
          </button>
          <button 
            className={`library-sort-button ${sortBy === 'lastRead' ? 'active' : ''}`}
            onClick={() => setSortBy('lastRead')}
          >
            <span className="sort-icon">🕒</span> Last Read
          </button>
        </div>
      </div>

      <div className="library-book-grid">
        {sortedBooks.map(book => (
          <div key={book.book_id} className="library-book" onClick={() => handleBookClick(book.book_id)}>
            <div className="library-book-cover-container">
              <img 
                src={book.cover_image_url}
                alt={book.title} 
                className="library-book-cover"
                loading="lazy"
              />
            </div>
            <div className="library-book-info">
              <h3 className="library-book-title">{book.title}</h3>
            </div>
          </div>
        ))}
        {sortedBooks.length === 0 && (
          <div className="library-no-books-message">
            No books found matching your search.
          </div>
        )}
      </div>
    </div>
  );
};

export default Library;